var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVbSizefitIllustrations19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 272.3 307.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #231f20;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st1 {\n        stroke: #ed1c24;\n        stroke-dasharray: 1;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 0.5,
    y: 0.5,
    width: 271.3,
    height: 306.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.35,23.48c4.36,28.46,18.93,48.28,11.1,77.61-9.51,35.64-32.97,68.93-29.51,107.22,2.34,25.88,11.58,50.71,13.74,76.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.42,23.48c-4.36,28.46-18.52,48.28-10.7,77.61,9.51,35.64,32.97,68.93,29.51,107.22-2.34,25.88-11.58,50.71-13.74,76.63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.37,143.69s-24.77,46.89-8.62,84.26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.94,143.83s24.77,46.89,8.62,84.26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbSizefitIllustrations19);
export default __webpack_public_path__ + "static/media/VB_SIZE&FIT_ILLUSTRATIONS-19.e350c6b78a11bbd4138da5d34528c2de.svg";
export { ForwardRef as ReactComponent };